export default __webpack_public_path__ + "static/media/logo-autopass.bfa82a01.svg";